import { connect } from 'react-redux';
import BankAccounts from './BankAccounts';
import { actions } from '../../../redux/modules/bankAccount';
import {resetStore} from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.bankAccounts,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(BankAccounts);
